import Icon from '../components/Icon.vue'

Icon.register({
  'search-dollar': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M505 442.7c9.3 9.4 9.3 24.6-0.1 34l-28.3 28.3c-9.3 9.4-24.5 9.4-33.9 0l-99.7-99.7c-4.5-4.5-7-10.6-7-17v-16.3c-35.3 27.6-79.7 44-128 44-114.9 0-208-93.1-208-208 0-114.9 93.1-208 208-208 114.9 0 208 93.1 208 208 0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7zM208 352c79.7 0 144-64.5 144-144 0-79.6-64.5-144-144-144-79.6 0-144 64.5-144 144 0 79.6 64.5 144 144 144zM235.1 199.4c18.6 5.6 31.6 23.4 31.6 43.4 0 24.5-19 44.4-42.7 45.1v16.1c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16.3c-11.3-0.6-22.3-4.5-31.4-11.3-3.9-2.9-4.1-8.8-0.6-12.1l11.8-11.2c2.8-2.6 6.9-2.8 10.1-0.7 3.9 2.4 8.3 3.7 12.8 3.7h28.1c6.5 0 11.8-5.9 11.8-13.2 0-5.9-3.6-11.2-8.8-12.7l-45-13.5c-18.6-5.6-31.6-23.4-31.6-43.4 0-24.5 19-44.4 42.7-45.1v-16.1c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v16.3c11.3 0.6 22.3 4.5 31.4 11.3 3.9 2.9 4.1 8.8 0.6 12.1l-11.8 11.2c-2.8 2.6-6.9 2.8-10.1 0.7-3.9-2.4-8.3-3.7-12.8-3.7h-28.1c-6.5 0-11.8 5.9-11.8 13.2 0 5.9 3.6 11.2 8.8 12.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/search-dollar.js
// module id = 1867
// module chunks = 0